// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__15HMn","upload":"Small_upload__3Z45g","imageWrap":"Small_imageWrap__1aUO2","removeBtn":"Small_removeBtn__3QMlU"};